
import React, { useState, useEffect } from 'react';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatDate = (date: Date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const h = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    const s = String(date.getSeconds()).padStart(2, '0');
    return `${y}-${m}-${d} ${h}:${min}:${s}`;
  };

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-slate-50 select-none">
      {/* Header - Android 横屏平板布局优化 */}
      <header className="relative bg-blue-700 text-white px-10 flex items-center shadow-md z-20 h-16">
        {/* 最左侧 Logo - 纯图标 */}
        <div className="flex items-center z-30">
          <div className="bg-white p-1.5 rounded-lg shadow-sm">
             <div className="w-8 h-8 bg-blue-700 rounded-full flex items-center justify-center text-[10px] font-black italic">LOGO</div>
          </div>
        </div>

        {/* 绝对居中标题 */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-10">
          <h1 className="text-2xl font-bold tracking-[0.2em] drop-shadow-sm">智能留样称系统</h1>
        </div>

        {/* 最右侧时间 - 适中字号 */}
        <div className="ml-auto z-30 bg-blue-800/40 px-5 py-1.5 rounded-xl border border-blue-400/20 shadow-inner">
          <div className="text-lg font-mono font-bold tracking-widest text-white/90">
            {formatDate(currentTime)}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 overflow-hidden p-4 relative">
        <div className="max-w-[1600px] mx-auto h-full overflow-hidden">
          {children}
        </div>
      </main>

      {/* Footer - 版权绝对居中，纯净模式 */}
      <footer className="bg-white border-t border-slate-100 px-8 py-2 flex items-center justify-center relative text-slate-400 text-xs h-10">
        <div className="font-bold tracking-wide opacity-60 uppercase">
          © 2026 版权所有：广东依时利科技有限公司
        </div>
      </footer>
    </div>
  );
};
